import { isFieldErrorResponse, useApiTradeV1SiteMaterialsUpdate } from 'api';
import { useNotification } from 'features';
import { translate } from 'i18n';

export const useUpdateSiteMaterial = () => {
  const { open } = useNotification();
  const { mutate: mutateSiteMaterial, isPending } = useApiTradeV1SiteMaterialsUpdate({
    mutation: {
      onError: (error) => {
        if (isFieldErrorResponse(error)) {
          const errorMessage = Object.keys(error.response?.data)
            .map((field) => error.response.data[field])
            .join(', ');
          open({ message: errorMessage, type: 'error' });
        }
      },
      onSuccess: () => {
        open({
          message: translate('backlog.siteMaterials.notifications.productLinkedSuccessfully', {
            namespace: 'features',
          }),
          type: 'success',
        });
      },
    },
  });

  const updateSiteMaterial = async (
    siteMaterialId: number,
    materialProductId: number,
    seller_label: string | undefined
  ) => {
    mutateSiteMaterial({
      data: { material_product_id: materialProductId, seller_label: seller_label },
      siteMaterialId: siteMaterialId.toString(),
    });
  };
  return { isPending, updateSiteMaterial };
};
